import { apiClient } from '@/lib/api-client';

export const SERVICES_ANNOUNCEMENT_ID = 'services-platform-launch-v1';

interface AnnouncementClaimWire {
  announcement_id: string;
  should_display: boolean;
  viewed_at: string;
}

export interface AnnouncementClaim {
  announcementId: string;
  shouldDisplay: boolean;
  viewedAt: string;
}

export async function claimAnnouncement(
  announcementId: string,
): Promise<AnnouncementClaim> {
  const response = await apiClient.post<AnnouncementClaimWire>(
    `/users/announcements/${encodeURIComponent(announcementId)}/claim/`,
    {},
  );

  return {
    announcementId: response.data.announcement_id,
    shouldDisplay: response.data.should_display,
    viewedAt: response.data.viewed_at,
  };
}
